function addRecentlyViewedProduct (sku) {
  var products = getCookie('recently_viewed') || '{}';
  products = JSON.parse(products);
  delete products[sku];
  products[sku] = Math.round((new Date()).getTime() / 1000);
  products = JSON.stringify(products);
  setCookie('recently_viewed', products);
  return products;
}

jQuery(function ($) {
  $body.on('click', '.js-quickview', function () {
    var $this = $(this);

    addRecentlyViewedProduct($this.data('sku'));
  });
});
